
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { apiShopLists, apiShopShopMoneyLogGetMoneyChartData } from "@/api/shop";
import SearchBtns from "@/components/search-btns.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import LsPagination from "@/components/ls-pagination.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import ExportData from "@/components/export-data/index.vue";
import * as echarts from "echarts";
import { copyClipboard } from "@/utils/util";

@Component({
  components: {
    LsPagination,
    DatePicker,
    elImageViewer,
    SearchBtns,
    ExportData,
  },
})
export default class OrderList extends Vue {
  // 界面表格数据
  pager: any = new RequestPaging();
  apiShopShopMoneyLogGetMoneyChartData = apiShopShopMoneyLogGetMoneyChartData;
  searchObj: any = {
    shop_id: "",
    type: "",
    time_type: 86400,
    next_limit: 10,
    clear_data: 0,
    start_time: "",
    end_time: "",
  };
  time_type_list: any = [
    {
      name: "日期",
      value: 86400,
    },
    {
      name: "小时",
      value: 3600,
    },
  ];
  money_type_list: any[] = [
    {
      id: 0,
      name: "全部",
    },
    {
      id: 1,
      name: "余额账本",
    },
    {
      id: 2,
      name: "不可提醒账本",
    },
    {
      id: 3,
      name: "可提现账本",
    },
  ];
  type_list: any[] = [];
  time: any = [];
  loading = false;
  shopList: any[] = [];

  // 日期选择器配置
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  handleSearch() {
    this.pager.page = 1;
    this.getList();
  }
  reset() {
    this.searchObj = {
      shop_id: "",
      type: "",
      time_type: 86400,
      next_limit: 10,
      clear_data: 0,
      start_time: "",
      end_time: "",
    };
    this.getList();
  }
  changeDate() {
    if (this.time.length) {
      this.searchObj.start_time = this.time[0];
      this.searchObj.end_time = this.time[1];
    }
  }
  getList() {
    this.loading = true; // 开始加载状态
    this.pager
      .request({
        callback: this.apiShopShopMoneyLogGetMoneyChartData,
        params: {
          ...this.searchObj,
          page_type: 0,
        }, // 传递搜索参数
      })
      .then((res: any) => {
        if (this.searchObj.clear_data) {
          this.searchObj.clear_data = 0;
        }
        this.loading = false; // 请求完成，停止加载状态
        try {
          // 先清理所有旧的图表实例和事件监听器
          this.pager.lists.forEach((v: any, index: any) => {
            const chartDom: any = document.getElementById(
              "chartContainer" + index,
            );
            if (chartDom) {
              const existingChart = echarts.getInstanceByDom(chartDom);
              if (existingChart) {
                existingChart.dispose(); // 销毁旧实例
              }
            }
          });

          this.pager.lists.forEach((v: any, index: any) => {
            if (v.date_list && v.date_list.length > 0) {
              let chartDom: any = document.getElementById(
                "chartContainer" + index,
              ) as any;
              let myChart: any = echarts.init(chartDom);
              myChart.setOption({
                title: [
                  {
                    text: v.name,
                    top: 10,
                    textStyle: {
                      fontSize: 18,
                    },
                  },
                  {
                    subtext: `金额${v.money},数量${v.num}`,
                    top: 10,
                    left: "right",
                    clickable: true,
                    triggerEvent: true,
                    subtextStyle: {
                      fontSize: 12,
                      color: "red",
                    },
                  },
                ],
                // toolbox: {
                //     feature: {
                //         saveAsImage: {},
                //     },
                // },
                xAxis: {
                  type: "category",
                  data: v.date_list.map((item: any) => item.time_date),
                },
                yAxis: {
                  type: "value",
                },
                legend: {
                  data: ["金额", "数量"],
                  bottom: 20,
                },
                itemStyle: {
                  // 点的颜色。
                  color: "red",
                },
                tooltip: {
                  trigger: "axis",
                },
                series: [
                  {
                    name: "金额",
                    data: v.date_list.map((item: any) => item.money),
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      borderWidth: 2, // 增加边框宽度，进一步扩大点击区域
                      borderColor: "transparent", // 透明边框不影响视觉
                    },
                    // 增强交互效果
                    emphasis: {
                      scale: true, // 鼠标悬停时放大
                      focus: "series", // 高亮当前系列
                    },
                  },
                  {
                    name: "数量",
                    data: v.date_list.map((item: any) => item.num),
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      borderWidth: 2, // 增加边框宽度，进一步扩大点击区域
                      borderColor: "transparent", // 透明边框不影响视觉
                    },
                    // 增强交互效果
                    emphasis: {
                      scale: true, // 鼠标悬停时放大
                      focus: "series", // 高亮当前系列
                    },
                  },
                ],
              });

              myChart.on("click", (params: any) => {
                console.log(params);
                let text = "";
                if (params.componentType === "title") {
                  text = params.event.target.style.text;
                } else {
                  text = params.value;
                }
                copyClipboard(text)
                  .then(() => {
                    this.$message.success("复制成功");
                  })
                  .catch((err) => {
                    this.$message.error("复制失败");
                    console.log(err);
                  });
                // console.log(this.pager.lists[index].date_list[params.dataIndex])
              });
            }
          });
        } catch (err) {}
      })
      .catch((error: any) => {
        console.error("获取订单列表失败:", error);
      });
  }

  async getShopList() {
    try {
      let res = await apiShopLists({ page_size: 9999 });
      this.shopList = res.lists;
    } catch (error) {}
  }
  async mounted() {
    await this.getShopList();
    this.getList();
  }
}
